import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TituloNavbarService {
  private readonly storageKey = 'titulo_navbar';
  private readonly storageMapKey = 'titulo_navbar_por_rota';
  private tituloSubject = new BehaviorSubject<string>(this.getInitialTitulo());
  titulo$ = this.tituloSubject.asObservable();

  setTitulo(titulo: string) {
    const valor = (titulo || '').trim() || 'Meus módulos';
    this.tituloSubject.next(valor);
    try {
      localStorage.setItem(this.storageKey, valor);
    } catch {}
  }

  setTituloParaRota(path: string, titulo: string): void {
    const rota = this.normalizePath(path);
    if (!rota) return;
    const valor = (titulo || '').trim();
    if (!valor) return;
    try {
      const mapa = this.getMapaTitulos();
      mapa[rota] = valor;
      localStorage.setItem(this.storageMapKey, JSON.stringify(mapa));
    } catch {}
  }

  getTituloParaRota(path: string): string | null {
    const rota = this.normalizePath(path);
    if (!rota) return null;
    try {
      const mapa = this.getMapaTitulos();
      const valor = mapa[rota];
      return valor && valor.trim() ? valor.trim() : null;
    } catch {
      return null;
    }
  }

  private getInitialTitulo(): string {
    try {
      const valor = localStorage.getItem(this.storageKey);
      if (valor && valor.trim()) return valor.trim();
    } catch {}
    return 'Meus módulos';
  }

  private getMapaTitulos(): Record<string, string> {
    try {
      const raw = localStorage.getItem(this.storageMapKey);
      const parsed = raw ? JSON.parse(raw) : {};
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch {
      return {};
    }
  }

  private normalizePath(path: string): string {
    const raw = (path || '').trim();
    if (!raw) return '';
    const semQuery = raw.split('?')[0].split('#')[0];
    const normal = semQuery.replace(/\/+$/, '') || '/';
    return normal;
  }
}
